import React, { useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import './App.css'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import LandingPage from './components/LandingPage'
import LoginPage from './components/LoginPage'
import Header from './components/Header'
import Feed from './components/Feed'
import Lightbox from './components/Lightbox'
import AccountsPage from './components/AccountsPage'

function App() {
  const [lightboxSrc, setLightboxSrc] = useState(null)
  const [isFeedLoading, setIsFeedLoading] = useState(true)
  const [refreshHandler, setRefreshHandler] = useState(null)
  const [isPulling, setIsPulling] = useState(false)

  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/app/*" element={
          <ProtectedRoute>
            <div className={`app-root ${isFeedLoading ? 'app-loading' : ''}`}>
              <Header
                isLoading={isFeedLoading}
                onRefresh={refreshHandler}
                isPulling={isPulling}
              />
              <main className="app-main">
                <Routes>
                  <Route
                    path="/"
                    element={
                      <Feed
                        onOpenLightbox={(src) => setLightboxSrc(src)}
                        onLoadingChange={setIsFeedLoading}
                        onRefreshReady={setRefreshHandler}
                        onPullingChange={setIsPulling}
                      />
                    }
                  />
                  <Route path="/accounts" element={<AccountsPage />} />
                  <Route path="*" element={<Navigate to="/app" replace />} />
                </Routes>
              </main>
              <Lightbox src={lightboxSrc} onClose={() => setLightboxSrc(null)} />
            </div>
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}

export default App
